import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { environment } from 'src/environments/environment';
import { citystate } from '../models/citystate/citystate';
import { commodityType } from '../models/commodityMaster/allcomoditytype';

@Injectable({
    providedIn: 'root'
})

export class LookupService {

    baseUrl = environment.Base_URL;
    lookupData : any
    constructor(private http: HttpClient){}

    lookup(data):Observable<any>{
        return this.http.get(this.baseUrl +'LookUp/GetLookupBylookupName/' +data)
    }

    getCityList():Observable<citystate[]>{
        return this.http.get(this.baseUrl+'Matser/GetCityMaster/')
        .pipe(map((data : citystate[]) => {
            const transformedData = data
            return transformedData;
        }));
    }

    getStateList():Observable<any>{
        return this.http.get(this.baseUrl+'Matser/GetStateMater')
    }

    getStateSList():Observable<any>{
        return this.http.get(this.baseUrl+'Matser/GetStateMaster')
    }


    AllComodityType(code):Observable<commodityType[]>{
        console.log('code',code)
      return this.http.get<commodityType[]>(this.baseUrl+ `Commodity/GetAllCommodityTypeByCode/${code}`)
      .pipe(map((data: commodityType[]) => {
          var transformedData = data;
          return transformedData
      }))
    }
  
    addNewCity(obj):Observable<citystate>{
        return this.http.post<citystate>(this.baseUrl+ 'Matser/AddCityMaster',obj)
        .pipe(map((data: citystate) => {
            var transformedData = data;
            return transformedData
        }))
    }

    getAggregatorList(code):Observable<any> {
        return this.http.get(this.baseUrl + 'Aggregation/GetAllAggregatorDropDown_Hirarchy/'+code, { observe: 'response' });
    }
    
    getCommodityDropdown():Observable<any>{
        return this.http.get<any>(this.baseUrl +'CommodityMaster/GetCommodityQualityDropDown',{ observe: 'response' })
    }
    
    getCommodityQuality(id):Observable<any>{
        return this.http.get<any>(this.baseUrl +'CommodityMaster/GetCommodityQuality/'+id)
    }

    getAllLanguages():Observable<any>{
        return this.http.get<any>(this.baseUrl +'api/TranslateCode/GetAllTranslateCodes/')
    }
}